import React, { useState } from "react";
import PropTypes from "prop-types";

import { cleanHTMLString } from "../../utils";

const CustomTextarea = ({
  name,
  label,
  value,
  required,
  validations,
  validationErrors,
  onChange,
  disabled
}) => {
  const [inputValue, setInputValue] = useState(value);
  const [error, setError] = useState("");

  const maxLength = validations.maxLength || 0;

  const handleChange = (e) => {
    const { value: v } = e.target;
    setInputValue(v);
    setError("");

    if (validations.maxLength && v.length > validations.maxLength) {
      setError(validationErrors.maxLength);
    }

    onChange(name, v);
  };

  return (
    <div className="form-group">
      <label htmlFor={name}>
        {label} {required && "*"}
      </label>
      <textarea
        id={name}
        name={name}
        value={cleanHTMLString(inputValue)}
        onChange={handleChange}
        required={required}
        disabled={disabled}
        className={`form-control ${error ? "is-invalid" : ""}`}
        formNoValidate
      />
      {maxLength > 0 && (
        <small
          className="text-muted"
          style={{ float: "right" }}
        >{`${inputValue.length}/${maxLength}`}</small>
      )}
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

CustomTextarea.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  validations: PropTypes.shape({
    maxLength: PropTypes.number
  }),
  validationErrors: PropTypes.shape({
    maxLength: PropTypes.string
  }),
  onChange: PropTypes.func.isRequired
};

CustomTextarea.defaultProps = {
  value: "",
  required: false,
  disabled: false,
  validations: {},
  validationErrors: {}
};

export default CustomTextarea;
